import { useDraftStore } from '@/lib/draftStore';
import { useTags } from '@/hooks/useAuctions';
import { formatMoney, formatCondition } from '@/lib/format';
import { Tag } from '@/components/ui/Tag';
import styles from './Step5Preview.module.css';

export const Step5Preview = () => {
  const draft = useDraftStore((s) => s.draft);
  const { data: allTags } = useTags();
  const selectedTags = allTags?.filter((t) => draft.tags.includes(t.slug)) ?? [];

  const endsAt = new Date(Date.now() + draft.duration_minutes * 60_000);

  return (
    <div className={styles.wrap}>
      <p className={styles.title}>Превью карточки</p>

      <div className={styles.previewCard}>
      <div className={styles.coverWrap}>
          {draft.photos[0] && (
            <img src={draft.photos[0].url_medium} alt="" className={styles.cover} />
          )}
          <div className={styles.edition}>
            <span className={styles.editionHash}>#</span>NEW
          </div>
        </div>
        
        <div className={styles.cardBody}>
          <div className={styles.cardTags}>
            {selectedTags.slice(0, 2).map((t) => (
              <Tag key={t.id} variant="subtle">{t.name_ru}</Tag>
            ))}
          </div>
          <p className={styles.cardTitle}>{draft.title || 'Без названия'}</p>
          <p className={styles.cardPrice}>{formatMoney(draft.start_price)}</p>
        </div>
      </div>

      <p className={styles.title}>Сводка</p>

      <dl className={styles.summary}>
        <Row label="Состояние" value={formatCondition(draft.condition)} />
        <Row label="Город" value={draft.city} />
        <Row label="Стартовая цена" value={formatMoney(draft.start_price)} mono />
        <Row label="Шаг" value={formatMoney(draft.min_step)} mono />
        {draft.buy_now_price && (
          <Row label="Buy Now" value={formatMoney(draft.buy_now_price)} mono />
        )}
        <Row
          label="Длительность"
          value={
            draft.duration_minutes < 60
              ? `${draft.duration_minutes} мин`
              : draft.duration_minutes < 24 * 60
              ? `${Math.round(draft.duration_minutes / 60)} ч`
              : `${Math.round(draft.duration_minutes / (24 * 60))} дн`
          }
        />
        <Row
          label="Завершится"
          value={endsAt.toLocaleString('ru-RU', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}
        />
        <Row label="Фото" value={`${draft.photos.length} шт`} />
      </dl>

      <div className={styles.note}>
        <p className={styles.noteTitle}>Что дальше</p>
        <p className={styles.noteBody}>
          После отправки аукцион попадёт на модерацию. Обычно проверка занимает
          до часа. Ты получишь уведомление, когда лот опубликуют.
        </p>
      </div>
    </div>
  );
};

const Row = ({ label, value, mono }: { label: string; value: string; mono?: boolean }) => (
  <>
    <dt className={styles.dt}>{label}</dt>
    <dd className={mono ? styles.ddMono : styles.dd}>{value}</dd>
  </>
);